import Snippet from "../../../../contents/docs/integrate/snippet.mdx";
import * as React from 'react';
export default {
  Snippet,
  React
};